// libraries.
import Spinner from 'react-bootstrap/Spinner';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// selectors.
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import {
  setDocuments,
  getSelectedTask,
} from '@domains/documents-review/store/slices/document-review-slice';
import { getFileType } from './utils';
import { useGetListDocumentsQuery } from '@domains/documents-review/store/api-slices/list-documents.endpoints';

// assets.
import { IconImage, IconPDF } from '@assets/icons';

// styles.
import { Line } from '@shared/styles';
import { WrapperDocs } from '../styles';

interface DocumentsListProps {
  nid?: string;
  onSelectDocument: (fileUrl: string) => void;
}

export const DocumentsList = ({
  nid,
  onSelectDocument,
}: DocumentsListProps) => {
  const dispatch = useDispatch();
  const country = useSelector(getCountry);
  const detailTask = useSelector(getSelectedTask);

  const {
    data: documents = [],
    isLoading,
    error,
  } = useGetListDocumentsQuery({
    country: country,
    nid: detailTask?.nid || nid,
  });

  useEffect(() => {
    if (documents.length > 0) dispatch(setDocuments(documents));
  }, [documents, dispatch]);

  if (isLoading)
    return (
      <div className="d-flex justify-content-center align-items-center h-100">
        <Spinner animation="border" variant="secondary" />
      </div>
    );

  if (error)
    return (
      <div className="d-flex justify-content-center align-items-center h-100">
        Error al cargar los documentos
      </div>
    );

  return (
    <div className="d-flex flex-column px-4 h-100">
      <div className="d-flex gap-2 flex-wrap">
        {documents.map(doc => (
          <WrapperDocs
            key={doc.id}
            onClick={() => doc.fileUrl && onSelectDocument(doc.fileUrl)}
          >
            {getFileType(doc.fileUrl) === 'pdf' ? <IconPDF /> : <IconImage />}
            <Line className="mt-4" />
            <div className="p-1 title">{doc.title}</div>
          </WrapperDocs>
        ))}
      </div>
    </div>
  );
};
